import { render, staticRenderFns } from "./BottomNavigation.patient.vue?vue&type=template&id=3f8d6f24&"
import script from "./BottomNavigation.patient.vue?vue&type=script&lang=ts&"
export * from "./BottomNavigation.patient.vue?vue&type=script&lang=ts&"
import style0 from "./BottomNavigation.patient.vue?vue&type=style&index=0&lang=postcss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports